<template>
		<div class="link-textarea__content" :style="{display: this.long ? 'block' : 'inline-block'}">
			<textarea
				ref="textarea"
				class="link-textarea"
				:class="classes"
				:style="styles"

				:cols="cols"
				:rows="rows"
				:value="p_value"
				:disabled="lv_disabled"
				:readonly="lv_readonly"

				:spellcheck="spellcheck"
				:placeholder="!!lv_disabled ? '' : placeholder"
				v-bind="$attrs"
				@input="pl_input">
			</textarea>
			<span v-if="isWordLimitVisible" class="link-input__count">{{ textLength }}/{{ upperLimit }}</span>
		</div>
</template>

<script>
    import {EditMixin} from "../mixins";

    export default {
        name: "link-textarea",
        mixins: [EditMixin],
        inject: {
            formItem: {default: null},
        },
        props: {
            value: {},
          	showWordLimit: Boolean,
            color: {type: String, default: 'info'},
            width: {default: 200},
            height: {default: 120},
            long: {type: Boolean},

            cols: {type: Number, default: null},
            rows: {type: Number, default: 4},
            spellcheck: {type: Boolean, default: false},
            placeholder: {type: String, default: '请输入文本...'},

            required: {type: Boolean,},                                                 //是否必输
            rules: {type: Array | String},                                              //校验规则
            validateOnInit: {type: Boolean,},                                           //是否在组件初始化的时候就开始校验
        },
        data() {
            return {
                p_value: this.value,
                isValidate: true,
                validateMsg: null,
                validateTimer: null,
            }
        },
        watch: {
            value(val) {
                this.p_value = val
            },
            p_value() {
                this.handleValidate()
            },
            required(val) {
                this.handleValidate();
                !!this.formItem && (this.formItem.p_required = val)
            },
        },
        computed: {
          upperLimit() {
            return this.$attrs.maxlength;
          },
          textLength() {
            if (typeof this.p_value === 'number') {
              return String(this.p_value).length;
            }
            return (this.p_value || '').length;
          },
          isWordLimitVisible() {
            return this.showWordLimit &&
                this.$attrs.maxlength &&
                !this.lv_readonly &&
                !this.lv_disabled;
          },
            classes() {
                return [
                    `link-textarea-color-${this.color}`,
                    {
                        'link-long-component': this.long,
                        'link-textarea-invalid': !this.isValidate,
                        'link-textarea-disabled': this.lv_disabled,
                        'link-textarea-readonly': this.lv_readonly,
                    },
                ]
            },
            styles() {
                const styles = {}
                !!this.width && (styles.width = this.$lv.$utils.unit(this.width))
                !!this.height && (styles.height = this.$lv.$utils.unit(this.height))
                return styles
            },
            currentRules() {
                let ret = []
                !!this.required && ret.push('required')
                !!this.rules && (ret = ret.concat(this.rules))
                return ret.length === 0 ? null : ret
            },
        },
        created() {
            if (!!this.formItem) {
                this.formItem.p_required = this.required
            }
            window.textareaVm = this
        },
        methods: {
            handleValidate() {
                this.isValidate = true
                this.validateMsg = null
                if (!this.currentRules) return
                if (!!this.validateTimer) {
                    clearTimeout(this.validateTimer)
                    this.validateTimer = null;
                }
                this.validateTimer = setTimeout(() => this.validate(), 100)
            },
            validate() {
                if (!this.currentRules) return true;
                const result = this.$rule.validate(this.p_value, this.currentRules)
                if (!!result) {
                    this.isValidate = false
                    this.validateMsg = result.msg
                    return false
                } else {
                    this.isValidate = true
                    this.validateMsg = null
                    return true
                }
            },
            cancelValidate() {
                this.isValidate = true
                this.validateMsg = null
            },
            pl_input(e) {
                this.p_value = e.target.value
                this.$emit('input', this.p_value)
            },
        }
    }
</script>

<style lang="scss">
	@include themeify {
		.link-textarea {
			display: inline-block;
			vertical-align: top;
			box-sizing: border-box;
			background-color: white;
			padding: 6px;
			font-size: 12px;
			color: $color-normal-sub-color;
			transition: all 0.15s linear;

			@include pl-colors(link-textarea) {
				border: solid 1px $value;
			}

			&:focus, &:hover:not(.link-textarea-disabled):not(.link-textarea-readonly) {
				border-color: $color-primary;
			}

			&.link-textarea-disabled {
				background-color: $color-normal-disabled;
				border-color: $color-info;
				color: $color-normal-disabled-text;
			}

			&:focus {
				outline: pl-var(outline);
				outline-width: 5px;
			}

			&::-webkit-input-placeholder { /* WebKit browsers */
				color: #d1d3d5;
			}

			&:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
				color: #d1d3d5;
			}

			&::-moz-placeholder { /* Mozilla Firefox 19+ */
				color: #d1d3d5;
			}

			&:-ms-input-placeholder { /* Internet Explorer 10+ */
				color: #d1d3d5;
			}

			&.link-textarea-readonly {
				color: $placeholder-color;
			}
		}

		.link-form-item-invalidate .link-textarea, .link-textarea.link-textarea-invalid {
			border-color: $color-error;

			&:focus, &:hover:not(.link-textarea-disabled):not(.link-textarea-invalid):not(.link-textarea-readonly) {
				border-color: $color-error;
			}
			&.link-textarea-invalid {
				border-color: $color-error;
			}

			&:focus {
				&.link-textarea-invalid {
					outline-color: rgba($color-error, 0.1);
				}
			}
		}
	}
	.link-textarea__content{
		position: relative;
		display: inline-block;
	}
	.link-input__count{
		color: #909399;
		background: #fff;
		position: absolute;
		font-size: 12px;
		bottom: 5px;
		right: 10px;
	}
</style>
